export type VideoSizeType = {
    width: number;
    height: number;
};

export type CardBoundingBoxType = {
    cardWidth: number;
    cardWidthPercent: number;
    cardHeight: number;
    cardHeightPercent: number;
    cardX: number;
    cardXPercent: number;
    cardY: number;
    cardYPercent: number;
    cardMajorAxis: number;
    cardMinorAxis: number;
}

export type CardType = {
    cardKey: number;
    companyKey: number;
    createdAt: string;
    creatorKey: number;    
    ownerKey: number;
    content: CardContentType;
    tags: number[];
    hasFrontImage: boolean;
    hasBackImage: boolean;
    isPublic: boolean;
}

export type TagType = {
    tagKey: number;
    parentKey: number | null;
    name: string;
    english?: string;
    japanese?: string;
}

export type LogType = {
    logKey: number;
    userKey: number;
    cardKey: number;
    action: string;
    occuredAt: string;
}

export type CardContentType = {
    lastName: CardDatumType[] | null;
    lastNamePhonetic: CardDatumType[] | null;
    firstName: CardDatumType[] | null;
    firstNamePhonetic: CardDatumType[] | null;
    companyName: CardDatumType[] | null;
    branch: CardDatumType[] | null;
    title: CardDatumType[] | null;
    email: CardDatumType[] | null;
    url: CardDatumType[] | null;
    headPhone: CardDatumType[] | null;
    headFax: CardDatumType[] | null;
    headAddress: CardDatumType[] | null;
    phone: CardDatumType[] | null;
    mobile: CardDatumType[] | null;
    fax: CardDatumType[] | null;
    address: CardDatumType[] | null;
    address2: CardDatumType[] | null;
    address3: CardDatumType[] | null;
    address4: CardDatumType[] | null;
    address5: CardDatumType[] | null;
}

export const emptyCardContent: CardContentType = {
    lastName: null,
    lastNamePhonetic: null,
    firstName: null,
    firstNamePhonetic: null,
    companyName: null,
    branch: null,
    title: null,
    email: null,
    url: null,
    headPhone: null,
    headFax: null,
    headAddress: null,
    phone: null,
    mobile: null,
    fax: null,
    address: null,
    address2: null,
    address3: null,
    address4: null,
    address5: null,
};

export const noLanguageFields: Record<keyof CardContentType, boolean> = {
    lastName: false,
    lastNamePhonetic: false,
    firstName: false,
    firstNamePhonetic: false,
    companyName: false,
    branch: false,
    title: false,
    email: true,
    phone: true,
    mobile: true,
    fax: true,
    address: false,
    address2: false,
    address3: false,
    address4: false,
    address5: false,
    headPhone: true,
    headFax: true,
    headAddress: false,
    url: true,
}

export type CardDatumType = {
    content: string;
    language?: LanguageEnum;
    face?: "front" | "back";
};

export type LanguageEnum = "english" | "japanese" | null;

export type UserType = {
    userKey: number | null;
    externalUserKey: number | null;
    employeeId: number | null; // This name taken from livelet, not the same as user id on livelet
    firstName: string | null; // This name taken from livelet, these exist incase there is a user with no card
    lastName: string | null; // This name taken from livelet, these exist incase there is a user with no card
    userToken: string | null;
    companyKey: number | null;
    uiLanguage: LanguageEnum;
    dismissedWarnings: number[];
    isDarkMode: boolean;
    isReducedMotion: boolean;
    isAdmin: boolean;
    isEditor: boolean;
    isCreator: boolean;
    isActive: boolean;
}

export type ExternalUserType = {
    id: number;
    employee_id: number;
    first_name: string;
    last_name: string;
}

export type CreateCardResponseType = {
    success: boolean;
    cardKey?: number;
    errorMessage?: string;
}

export type DeleteCardResponseType = {
    success: boolean;
    errorMessage?: string;
}

export type ExportCardsResponseType = {
    csv: string;
}

export type VisionLoadingType = {
    front: boolean;
    back: boolean;
};

export type CanvasRefPairType = {
    front: React.MutableRefObject<HTMLCanvasElement | null>;
    back: React.MutableRefObject<HTMLCanvasElement | null>;
};

export type CanvasesRefType = {
    scanner: CanvasRefPairType,
    viewer:  CanvasRefPairType,
};
